import { Z_INDEX } from '@/components/shared/constants/zIndex';
import styled from '@emotion/styled';
import { H2, Input, Link, rem } from '@triumph/design-system';

export const HeaderContainer = styled.div`
    background-color: ${({ theme }) => theme.colors.primary.tbcNavy};
    height: ${rem(64)};
    flex-shrink: 0;
    padding: 0 ${rem(30)};
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: ${Z_INDEX.HEADER};
`;

export const Wrapper = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0px ${rem(32)};
    justify-content: end;
    gap: ${rem(20)};
`;

export const Title = styled(H2)`
    color: ${({ theme }) => theme.colors.greyscale.white};
    font-family: ${({ theme }) => theme.typography.fontFamilies.primary};
    cursor: pointer;
`;

export const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${rem(24)};
`;

export const ApplicantWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${rem(24)};
`;

export const ViewApplicantListLink = styled(Link)`
    color: ${({ theme }) => theme.colors.greyscale.white};
    margin-top: ${rem(10)};
    cursor: pointer;

    &:hover {
        color: ${({ theme }) => `${theme.colors.greyscale.white}`};
    }

    &:visited {
        color: ${({ theme }) => theme.colors.greyscale.white};
    }

    &.active {
        color: #60A5FA;
    }
`;

export const SearchApplicantNameInput = styled(Input)`
    background-color: ${({ theme }) => theme.colors.greyscale.white};
    border-radius: ${rem(4)};
    height: 48px;
    width: 240px;

    input {
        height: ${rem(32)};
        font-size: ${rem(16)};

        &::placeholder {
            font-size: ${rem(16)};
            color: ${({ theme }) => theme.colors.greyscale.gray50};
        }
    }

    svg {
        height: ${rem(32)};
        width: ${rem(32)};
    }
`;

export const VerticalLine = styled.div`
    border-left: 2px solid ${({ theme }) => theme.colors.greyscale.white};
    height: ${rem(24)};
    margin-top: 10px;
    align-self: center;
`;

export const MenuWrapper = styled.div`
    position: relative;

    /* Target the PrimeReact menu overlay that renders at body level */
    :global(.p-menu.p-menu-overlay) {
        z-index: ${Z_INDEX.HEADER_DROPDOWN} !important;
    }
`;
